import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'
import { OrdersType } from './OrdersType'

export function SignatureField() {
  const texts = useTexts()
  const {
    field: { value: isChecked },
  } = form.useFormField('includeSignatureChecked')
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  return (
    <>
      <form.Checkbox
        name="includeSignatureChecked"
        label={texts.signature}
        testId="driver-assistance-form-signature-field"
        disabled={formDisabled}
        validateOn="blur change"
      />
      {isChecked && <OrdersType name="includeSignature" disabled={formDisabled} />}
    </>
  )
}
